export const baseUrl = `${import.meta.env.VITE_BASE_URL}/api/v1`;
export const coreApiBaseUrl =
  import.meta.env.VITE_CORE_API_URL ||
  `${import.meta.env.VITE_BASE_URL}/api/v1`;

export const autocompleteAirportUrl = `${baseUrl}/flights/airports`;
